module.exports = __webpack_public_path__ + "static/media/phonemeIsolation-klarte-oppgaver.c31fd0a2.mp3";